<template>
  <div>
    <section class="orderSect">
      <!--S 检索-->
      <el-form inline :model="formInline">
        <el-form-item :label="expecttitle">
          <el-date-picker
          v-model="formInline.expectedDelvDate"
          type="daterange"
          range-separater="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="formInline.orderDateOptions"
          :unlink-panels = "true" clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-if="sppsfw == 1" v-model="formInline.timeSlot" placeholder="请选择" class="formTimeSlot" clearable>
            <el-option label="中午" value="09:00:00"></el-option>
            <el-option label="晚上" value="15:00:00"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发货时间">
          <el-date-picker
          v-model="formInline.deliveryDate"
          type="daterange"
          range-separater="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="formInline.orderDateOptions"
          :unlink-panels = "true" clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="订单号" class="codeSerIpt">
          <el-input v-model="formInline.orderno" placeholder="请输入订单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="快递单号">
          <el-input v-model="formInline.expressno" placeholder="请输入快递单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="formInline.phone" placeholder="请输入手机号码" clearable></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="getAllExps">查询</el-button>
        </el-form-item>
        <el-form-item >
            <el-button type="primary" plain @click="exportExcel">导出</el-button>
        </el-form-item>
        <em class="simpleSearch" @click="highShow = !highShow">{{highShow?'精简筛选':'高级筛选'}}</em>
        <div class="none" :class="{'block':highShow}">
          <el-form-item label="收货人">
            <el-input  v-model="formInline.Name" placeholder="请输入收货人" clearable></el-input>
          </el-form-item>
          <el-form-item label="预售品牌">
          <!-- 预售品牌下拉组件 S -->
          <PresaleBrandSelect @brandObtain="brandReceive"></PresaleBrandSelect>
          <!-- 预售品牌下拉组件 E -->
          </el-form-item>
          <el-form-item label="供应方">
            <el-select v-model="formInline.supplier" filterable placeholder="请选择或输入" clearable>
              <el-option v-for="(item,index) in supplierList" :key="index" :label="item.label" :value="item.value" :title="item.label" clearable></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="代销方">
            <el-select v-model="formInline.consigner" filterable placeholder="请选择或输入" clearable>
              <el-option v-for="(item,index) in ConsignmentLists" :key="index" :label="item.label" :value="item.value" :title="item.label"></el-option>
            </el-select>
          </el-form-item>
          <!-- 配送方下拉组件 S -->
          <DeliveryAreaSelect @deliveryObtain="deliveryReceive"></DeliveryAreaSelect>
          <!-- 配送方下拉组件 E -->
          <el-form-item label="快递内容">
            <el-input v-model="formInline.expcontent" placeholder="请输入快递内容" clearable></el-input>
          </el-form-item>
        </div>
      </el-form>
    <!--E 检索-->

    <!--S 全部快递列表-->
    <div class="allOrderTab individualiz">
      <el-form :model="formInline" inline size="medium">
        <el-form-item class="borderline">
          <em class="greyColor">发货状态</em>
          <el-checkbox-group v-model="formInline.deyStatus" @change="changeStatus">
            <el-checkbox v-for="(item,index) of DeliveryStatusLists" :label="item.value" :key="index">{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item class="borderline">
          <em class="greyColor">订单状态</em>
          <el-checkbox-group v-model="formInline.orderState" @change="changeStatus">
            <el-checkbox v-for="(item,index) of ordStateLists" :label="item.value" :key="index">{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item class="borderline">
          <el-checkbox v-model="formInline.ReissueExpress" @change="changeStatus">补发快递</el-checkbox>
        </el-form-item>
        <el-form-item class="borderNone">
          <el-button type="primary" plain @click="specMange = true">任务列表</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="loading" :data="allExpressData" ref="expressTable" class="orderTable comTable" border :maxHeight="tableHeight">
        <el-table-column type="index" label="序号" fixed width="80"></el-table-column>
        <el-table-column label="快递单号/发货状态/打印状态" prop="deliverstate" sortable fixed min-width="420">
          <template slot-scope="scope">
            <section class="expressWrap flexUI">
              <div>
                <p>{{scope.row.expno}}</p>
                <small v-if="scope.row.deliverstate!=0">发货时间：<br>{{ dateTime(scope.row.deliverdate, 1)}}</small>
              </div>
              <div>
                <p>
                  <em :class="[{'blueColor':scope.row.deliverstate==1 || scope.row.deliverstate==3},{'orangeColor':scope.row.deliverstate==0},{'redColor':scope.row.deliverstate==2 || scope.row.deliverstate==6},{'greyColor':scope.row.deliverstate==4},{'greenColor':scope.row.deliverstate==5}]">{{scope.row.deliverstate | deliverStateFilter}}</em>
                  <template v-if="scope.row.bprint != 0 || scope.row.deliverstate!=1&&scope.row.deliverstate!=5&&scope.row.deliverstate!=6">
                    &nbsp;/
                    <i v-if="scope.row.bprint == 0" class="orangeColor">待打印</i>
                  </template>
                  <i v-if="scope.row.bprint == 1" class="blueColor">已打印</i>
                </p>
                <p class="greyColor">
                  <span v-if="scope.row.deliverstate!=0">{{exptypes[scope.row.exptype] }}「{{ scope.row.handletype | handleTypeFilter}}」</span> <el-tag v-if="scope.row.bnew == 0 ||scope.row.ordertype==2" type="" effect="dark" title="补发快递">补</el-tag>
                </p>
              </div>
            </section>
          </template>
        </el-table-column>
        <el-table-column label="快递内容" prop="expcontent" sortable min-width="350">
          <template slot-scope="scope">
            <small>订单号：{{scope.row.orderno}}</small>
            <p class="textFl" :title="scope.row.expcontent">{{scope.row.expcontent}}</p>
            <small>{{expecttitle}}：{{ dateTime(scope.row.recvdate, 2)}}</small>
          </template>
        </el-table-column>
        <el-table-column label="收货信息" prop="fulladdr" sortable min-width="350">
          <template slot-scope="scope">
            <div class="shouMsg">
              <em v-if="scope.row.receivername">{{scope.row.receivername}}</em>
              <em v-if="scope.row.receivertel">{{scope.row.receivertel}}</em>
            </div>
            <p v-if="scope.row.fulladdr" class="greyColor textFl" :title="scope.row.fulladdr">{{scope.row.fulladdr}}</p>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" prop="ordstate" sortable min-width="150">
          <template slot-scope="scope">
            <span :class="[{'greenColor':scope.row.ordstate==5 || scope.row.ordstate==3 || scope.row.ordstate==4},{'orangeColor':scope.row.ordstate==1 || scope.row.ordstate==0},{'greyColor':scope.row.ordstate==8 || scope.row.ordstate==7},{'blueColor': scope.row.ordstate==6},]">{{scope.row.ordstate | orderStateFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单金额(￥)" prop="allamount" sortable min-width="200">
          <template slot-scope="scope">
            <em class="priceFont"><em>￥</em>{{scope.row.allamount}}</em>
          </template>
        </el-table-column>
        <el-table-column label="权限归属" prop="operpower" sortable min-width="150">
          <template slot-scope="scope">
            <p class="textFl" :title="scope.row.operpower | operpOwerFilter">{{scope.row.operpower | operpOwerFilter}}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="150">
          <template slot-scope="scope">
            <el-dropdown trigger="click" @command="handleCommand" placement="bottom-start">
              <span class="el-dropdown-link">
                全部操作<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{'type': 'orderDetail', 'orderno': scope.row.orderno,'expcode': scope.row.expcode}">订单详情</el-dropdown-item>
                <el-dropdown-item :command="{'type': 'expressDetail', 'expcode': scope.row.expcode}">快递详情</el-dropdown-item>
                <el-dropdown-item v-if="scope.row.fexpno != '0' && scope.row.bnew == 1"
                  :command="{'type': 'expressDetail', 'expcode': scope.row.fexpno}">合并快递详情</el-dropdown-item>
                <div v-if="( scope.row.cooqydm && scope.row.bshipper == 1 ) || !scope.row.cooqydm">
                  <el-dropdown-item :command="{'type': 'replacement', 'expcode': scope.row.expcode}"
                    v-if="menusmd.indexOf('BFSQ') == -1 && scope.row.deliverstate == 1 && scope.row.ordstate < 6 && scope.row.updateFlag &&ElementControls('jinshizun')!=1">补发</el-dropdown-item>
                  <el-dropdown-item
                    :command="{
                      'type': 'applyforReplacement',
                      'orderparam': {
                        'orderno': scope.row.orderno,
                        'receivername': scope.row.receivername,
                        'receivertel': scope.row.receivertel,
                        'fulladdr': scope.row.fulladdr,
                        'expno': scope.row.expno,
                        'expcode': scope.row.expcode
                      }
                    }"
                    v-if="(menusmd.indexOf('BFSQ') != -1 || ElementControls('jinshizun')==1) && (scope.row.deliverstate == 1 ||scope.row.deliverstate==5||scope.row.deliverstate==6) && scope.row.ordstate < 6">申请补发</el-dropdown-item>
                  <el-dropdown-item :command="{'type': 'addExpressno', 'expcode': scope.row.expcode, 'expmemo': scope.row.expmemo}">追加快递单号</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.deliverstate != 4 &&  scope.row.updateFlag" :command="{'type': 'editExpressAmount', 'editExpinfo': scope.row}">编辑</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.deliverstate == 1||scope.row.deliverstate == 5||scope.row.deliverstate == 6 &&  scope.row.updateFlag" :command="{'type': 'returnGoods', 'expcode': scope.row.expcode}">退货</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.ordstate == 5&&(scope.row.deliverstate==1||scope.row.deliverstate==5||scope.row.deliverstate==6) &&  scope.row.updateFlag" :command="{'type': 'normalStatement', 'finishFlag': 0, 'orderno': scope.row.orderno}">正常结单</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.ordstate < 6 &&  scope.row.updateFlag" :command="{'type': 'problemStatement', 'finishFlag': 1, 'orderno': scope.row.orderno}">问题结单</el-dropdown-item>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="noData">
            <p class="firstSeeTip" v-if="firstShow">亲，页面初始不加载数据哦～<br/>请先设置查询条件，然后点击【<i class="blueColor">查询</i>】</p>
            <span v-else>暂无数据</span>
          </div>
        </template>
      </el-table>
    </div>
    <!--E 全部快递列表-->
    <Page :pageTotal="pagebean.totalnum" :currentPage="pagebean.currentpage" @nowPageParam="setPageparam"></Page>
    </section>

    <!--S 订单详情组件-->
    <OrderDetail :orderDetailBox="orderDetailShow" :expcodes="expcode" :orderno="orderno" @closeODBox="orderDetailShow = false"></OrderDetail>
    <!--E 订单详情组件-->

    <!--S 快递详情组件-->
    <DeliveryDetail :deliveryDetailBox="expressDetailShow" :expcode="expcode" @closeDDBox="expressDetailShow = false"></DeliveryDetail>
    <!--E 快递详情组件-->

    <!--S 追加快递单号/退货备注/结单备注组件-->
    <ExpressMemo :expressMemoBox="expressMemo" :memo="expmemo" :operateMemo="operateType" :shadeTrue="firstTrue" @closeVal="clsBtnVal" @closeEMemoBox="closeExpressMemo"></ExpressMemo>
    <!--E 追加快递单号/退货备注/结单备注组件-->

    <!--S 修改运费组件-->
    <EditExpressAmount :orderAmountBox="deliveryAmountShow" :editExpinfo="editExpinfo" @closeAmVal="closeAVal" @closeOAmountBox="closeOrderAmount"></EditExpressAmount>
    <!--E 修改运费组件-->

    <!--S 申请补发组件-->
    <ApplyForReplace :applyForBox="applyForShow" :orderparam="orderparam" @closeApplyVal="closeApplyVal" @closeApplyBox="closeApplyFor"></ApplyForReplace>
    <!--E 申请补发组件-->

    <!-- S 任务列表弹窗 -->
    <TaskList :specMange="specMange" :eleType="7" @closeTask="closeTask"></TaskList>
    <!-- E 任务列表弹窗 -->

  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import api from '../../../apis/api';
import { dateTime } from '../../../util/dateTime';
export default {
  name: "AllOrder",
  data() {
    return {
      specMange: false,
      firstShow:true,//初始可见
      highShow: false, //是否展示高级筛选
      brandList: [], //预售品牌列表
      deliveryList: [ ], //配送方列表
      supplierList: [], //供应方列表
      ConsignmentLists: [], //代销方列表
      DeliveryStatusLists: [
        { label: "待发货", value: 0 },
        { label: "已发货", value: 1 },
        { label: "退货", value: 2 },
        { label: "已补发", value: 3 },
        { label: "已签收", value: 5 },
        { label: "异常签收", value: 6 },
      ], //发货状态
      ordStateLists: [
        { label: "待付款", value: 0 },
        { label: "已付款/待处理", value: 1 },
        { label: "已退款", value: 2 },
        { label: "配货中", value: 3 },
        { label: "部分发货", value: 4 },
        { label: "已发货", value: 5 },
        { label: "正常结单", value: 6 },
        { label: "问题结单", value: 7 },
        { label: "订单取消", value: 8 },
      ], //订单状态
      //检索
      formInline: {
        Name: "", //收货人
        brand: "", //预售品牌
        orderno: "", //订单号
        expressno: "", //快递单号
        phone: "", //手机号
        expectedDelvDate: "", //期望发货日期
        deliveryDate: '', // 发货时间
        timeSlot: "", //中午、晚上时间段选择
        supplier:"", //供应方
        consigner: "", //代销方
        deliveryer: "", //配送方
        deyStatus:[], //发货状态
        ReissueExpress:"",//补发快递
        orderState: [],
        expcontent: '', // 检索的快递内容
        orderDateOptions: {
          shortcuts: [
            {
              text: "今天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime());
                picker.$emit("pick", [start, end]);
              }
            },{
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              }
            }
          ]
        }
      },
      allExpressData: [], //全部快递数据
      tableHeight: window.innerHeight * 0.8, //表格动态高度
      orderDetailShow:false, //订单详情
      expressDetailShow:false, //快递详情
      applyForShow:false, //申请补发弹窗
      editOdBtnVal:'',//申请补发是确定还是取消
      operateType:'addExpressno', //默认追加快递单号操作
      expressMemo:false, //快递备注弹窗
      btnVal:'', //取消订单备注按钮关闭还是确定
      deliveryAmountShow:false, //修改运费弹窗
      amountBtnVal:'',//修改修改运费是确定还是取消
      pagebean: {
        pagesize: 30,
        currentpage: 1
      },//分页
      loading: true,//加载
      exptypes: {},//所有的快递方式
      expcode: '',//快递编号
      orderno: '',
      orderparam: {},//申请补发参数
      editExpinfo: {},//修改的快递对象
      finishFlag: '',//结单标识
      expecttitle: '',//期望发货日期标题
      menusmd: '',//菜单权限
      sppsfw: 0,//是否开通同城配送
      firstTrue: true, // 防止多次点击
      expmemo: '',//快递备注
    };
  },
  components: {
    Page: resolve => require(["@/components/common/Page.vue"], resolve),
    OrderDetail: resolve => require(["@/components/common/OrderDetail.vue"], resolve), //查看订单详情组件
    ApplyForReplace: resolve => require(["@/components/DeliveryFolder/applyForReplacement.vue"], resolve), //申请补发组件
    ExpressMemo: resolve => require(["@/components/DeliveryFolder/ExpressMemo.vue"], resolve), //追加快递单号/退货备注/结单备注组件
    EditExpressAmount: resolve => require(["@/components/common/EditExpressAmount.vue"], resolve), //修改运费组件
    DeliveryDetail: resolve => require(["@/components/common/DeliveryDetail.vue"], resolve), //快递详情组件
    DeliveryAreaSelect: resolve => require(["@/components/common/DeliveryAreaSelect.vue"], resolve), // 配送方下拉组件
    PresaleBrandSelect: resolve => require(["@/components/common/PresaleBrandSelect.vue"], resolve), // 预售品牌下拉组件
    TaskList: resolve =>require(["@/components/StatisticsFolder/TaskList.vue"], resolve), // 任务列表组件
  },
  watch: {

  },
  methods: {
    //操作指令
    handleCommand(command) {
      if(command.type == 'orderDetail'){ //订单详情
        this.orderno = command.orderno
        this.orderDetailShow = true
      }else if(command.type == 'replacement'){ //补发
        this.operateType = 'replacement'
        this.expcode = command.expcode
        this.expressMemo = true
      }else if(command.type == 'applyforReplacement'){ //申请补发
        let orderparams = {
          'orderno': command.orderparam.orderno,
          'receivername': command.orderparam.receivername,
          'receivertel': command.orderparam.receivertel,
          'fulladdr': command.orderparam.fulladdr,
          'expno': command.orderparam.expno,
          'expcode': command.orderparam.expcode
        };
        this.orderparam = orderparams
        this.applyForShow = true
      }else if(command.type == 'addExpressno'){ //追加快递单号
        this.expmemo = command.expmemo;
        this.expcode = command.expcode
        this.operateType = 'addExpressno'
        this.expressMemo = true
      }else if(command.type == 'editExpressAmount'){ //修改运费
        this.editExpinfo = command.editExpinfo
        this.deliveryAmountShow = true
      }else if(command.type == 'returnGoods'){ //退货
        this.expcode = command.expcode
        this.operateType = 'returnGoods'
        this.expressMemo = true
      }else if(command.type == 'expressDetail'){ //快递详情
        this.expcode = command.expcode
        this.expressDetailShow = true
      }else if(command.type == 'normalStatement' || command.type == 'problemStatement'){ //结单备注
        this.operateType = 'Statement'
        this.orderno = command.orderno
        this.finishFlag = command.finishFlag
        this.expressMemo = true
      }
    },
    //关闭快递备注弹窗确定还是取消
    clsBtnVal(val){
      this.btnVal = val;
    },
    //确定取消快递备注
    closeExpressMemo(lmemoForm){
      this.expressMemo = false; //弹窗
      if(Number(this.btnVal)){
        if(this.firstTrue) {
          if(this.operateType == 'addExpressno'){
            let params = {
              expcode: this.expcode,
              expnos: lmemoForm.expressNos
            }
            this.firstTrue = false;
            api.APPENDEXPNO(params).then(res => {
              if(res.data.status == '200') {
                Message({
                  type: 'success',
                  message: '追加快递单号成功!'
                });
                this.getAllExps()
              } else {
                Message({
                  type: 'error',
                  message: res.data.message
                });
              }
              this.firstTrue = true;
            })
          }else if(this.operateType == 'returnGoods'){
            let params = {
              expcode: this.expcode,
              expmemo: lmemoForm.returnMemo
            }
            this.firstTrue = false;
            api.REFUNDCONCATEXPINFO(params).then(res => {
              if(res.data.status == '200') {
                Message({
                  type: 'success',
                  message: '退货成功!'
                });
                this.getAllExps()
              } else {
                Message({
                  type: 'error',
                  message: res.data.message
                });
              }
              this.firstTrue = true;
            })
          }else if(this.operateType == 'Statement'){
            let params = {
              orderno: this.orderno,
              finishFlag: this.finishFlag,
              memo: lmemoForm.statementMemo
            }
            this.firstTrue = false;
            api.FINISHORDER(params).then(res => {
              if(res.data.status == '200') {
                Message({
                  type: 'success',
                  message: '结单成功!'
                });
                this.getAllExps()
              } else {
                Message({
                  type: 'error',
                  message: res.data.message
                });
              }
              this.firstTrue = true;
            })
          }else if(this.operateType == 'replacement'){
            let params = {
              expcode: this.expcode,
              expcontent: lmemoForm.replaceContent,
              chooseaddress: lmemoForm.chooseaddress?1:0,
            }
            if(lmemoForm.chooseaddress) {
              params.contacts = lmemoForm.contacts;
              params.contactphone = lmemoForm.contactphone;
              params.provincecode = lmemoForm.provincecode;
              params.province = lmemoForm.province;
              params.citycode = lmemoForm.citycode;
              params.city = lmemoForm.city;
              params.districtcode = lmemoForm.districtcode;
              params.district = lmemoForm.district;
              params.addrdet = lmemoForm.addrdet;
            }
            this.firstTrue = false;
            api.READDEXPINFO(params).then(res => {
              if(res.data.status == '200') {
                Message({
                  type: 'success',
                  message: '补发成功!'
                });
                this.getAllExps()
              } else {
                Message({
                  type: 'error',
                  message: res.data.message
                });
              }
              this.firstTrue = true;
            })
          }
        }
      }
    },
    // 关闭任务列表弹窗
    closeTask() {
        this.specMange = false;
    },
    //修改修改运费是确定还是取消
    closeAVal(val){
      this.amountBtnVal = val;
    },
    //修改运费弹窗
    closeOrderAmount(){
      this.deliveryAmountShow = false; //修改运费弹窗
      this.getAllExps()
    },
    //申请补发是确定还是取消
    closeApplyVal(val){
      this.editOdBtnVal = val;
    },
    //关闭申请补发弹窗
    closeApplyFor(val){
      this.applyForShow = false; //修改订单弹窗
      if(Number(this.editOdBtnVal)){
        this.getAllExps()
      }
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.expressTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130;
      //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
    },

    //设置分页数据
    setPageparam(nowPageSize, nowCurrentPage) {
      if(nowPageSize) {
        this.pagebean.pagesize = nowPageSize
      }
      if(nowCurrentPage) {
        this.pagebean.currentpage = nowCurrentPage
      }
      this.getAllExps()
    },

    //出发选择框
    changeStatus() {
      this.getAllExps()
    },

    // 配送方下拉选择值
    deliveryReceive(value) {
      this.formInline.deliveryer = value;
    },
    // 预售品牌下拉选择值
    brandReceive(value) {
      this.formInline.brand = value;
    },

    //查询全部快递列表
    getAllExps() {
      this.loading = true
      let params = {
        stardate: this.formInline.expectedDelvDate && this.formInline.expectedDelvDate[0] ? this.dateTime(this.formInline.expectedDelvDate[0]) : '',
        enddate: this.formInline.expectedDelvDate && this.formInline.expectedDelvDate[1] ? this.dateTime(this.formInline.expectedDelvDate[1]) : '',
        deliverysdate: this.formInline.deliveryDate && this.formInline.deliveryDate[0] ? `${this.dateTime(this.formInline.deliveryDate[0])} 00:00:00` : '',
        deliveryedate: this.formInline.deliveryDate && this.formInline.deliveryDate[1] ? `${this.dateTime(this.formInline.deliveryDate[1])} 23:59:59` : '',
        dateAmPm: this.formInline.timeSlot,
        orderno: this.formInline.orderno, //订单号
        name: this.formInline.Name,
        mobileNumber: this.formInline.phone,
        expcode: '',
        deliverstate: this.formInline.deyStatus,//快递状态
        expno: this.formInline.expressno,
        brandcode: this.formInline.brand,
        proxyqydm: this.formInline.consigner,
        supplyqydm: this.formInline.supplier,
        expresscode: this.formInline.deliveryer,
        bnew: this.formInline.ReissueExpress ? 0 : null,//是否为补发快递
        ordstate: this.formInline.orderState,
        expcontent: this.formInline.expcontent, // 检索的快递内容
        pageparam: this.pagebean
      }
      api.GET_ALLEXPINFOLIST(params).then(res => {
        if(res.data.status == '200') {
          this.firstShow = false;//初始提示隐藏
          this.allExpressData = res.data.data
          this.pagebean = res.data.pagebean
        } else {
          this.allExpressData = []
        }
        this.loading = false
      })
    },

    //获取所有的可用快递方式
    getAllExpTypes() {
      if(localStorage.getItem("exptypes")){
        this.exptypes = JSON.parse(localStorage.getItem("exptypes"))
      } else {
        api.GET_ALLEXPMODENAMECACHE({}).then(res => {
          if(res.data.status == '200') {
            this.exptypes = res.data.data.expmodeMap
            localStorage.setItem("exptypes",JSON.stringify(this.exptypes))
          }
        })
      }
    },

    //全部快递导出
    exportExcel() {
      this.loading = true
      let params = {
        stardate: this.formInline.expectedDelvDate && this.formInline.expectedDelvDate[0] ? this.dateTime(this.formInline.expectedDelvDate[0]) : '',
        enddate: this.formInline.expectedDelvDate && this.formInline.expectedDelvDate[1] ? this.dateTime(this.formInline.expectedDelvDate[1]) : '',
        deliverysdate: this.formInline.deliveryDate && this.formInline.deliveryDate[0] ? `${this.dateTime(this.formInline.deliveryDate[0])} 00:00:00` : '',
        deliveryedate: this.formInline.deliveryDate && this.formInline.deliveryDate[1] ? `${this.dateTime(this.formInline.deliveryDate[1])} 23:59:59` : '',
        dateAmPm: this.formInline.timeSlot,
        orderno: this.formInline.orderno, //订单号
        name: this.formInline.Name,
        mobileNumber: this.formInline.phone,
        expcode: '',
        deliverstate: this.formInline.deyStatus,//快递状态
        expno: this.formInline.expressno,
        brandcode: this.formInline.brand,
        proxyqydm: this.formInline.consigner,
        supplyqydm: this.formInline.supplier,
        expresscode: this.formInline.deliveryer,
        bnew: this.formInline.ReissueExpress ? 0 : null,//是否为补发快递
        ordstate: this.formInline.orderState,
        expcontent: this.formInline.expcontent, // 检索的快递内容
        pageparam: this.pagebean
      }
      api.EXPORTALLEXPINFO(params).then(res => {
        if(res.data.status == '200') {
          if (res.data.data.flag == 1) {
            window.location.href = res.data.data.url
          } else {
            Message({
            type: 'success',
            message: res.data.message
          });
          }
        } else {
          Message({
            type: 'error',
            message: res.data.message
          });
        }
        this.loading = false
      })
    },

  },
  filters: {
    exptypeFilter(value) {
      return value
    }
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    //在dom渲染之后
    setTimeout(() => {
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
      this.formInline.expectedDelvDate = [start, '']
      this.getHeight()
      this.getAllExps()
      this.getAllExpTypes()
      this.expecttitle = localStorage.getItem("pubordprintinfo") ? JSON.parse(localStorage.getItem("pubordprintinfo")).expecttitle : ''
      this.menusmd = localStorage.getItem("menusmd") ? localStorage.getItem("menusmd") : ''
    }, 200);
    this.sppsfw = Number(this.ElementControls('sppsfw'))
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight); //销毁监听浏览器视窗变化
  }
};
</script>

<style scoped>
@import "../Css/Style.css";
.firstSeeTip {padding-bottom:30px;width:320px;margin:0 auto; line-height:35px; font-size: 16px; color:#FA2F2F; text-align: left; padding-left:50px;}
.individualiz .el-form:nth-child(2) {padding-top:0!important;}
</style>





// WEBPACK FOOTER //
// src/views/DeliveryFolder/AllExpress/AllExpressList.vue